import React from 'react'

import IconArrowDown from 'client/icons/ChevronDown'

import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import Button from 'src/comps/Atom/Buttons/Button'

const ShowMore = ({
  onClick,
  children,
  dataTestId,
  outlinedShowMoreButton,
}: {
  onClick: () => void
  children: React.ReactNode
  dataTestId?: string
  outlinedShowMoreButton?: boolean
}) => {
  const { sendEvent: sendClickShowMore } = useKafkaEvent({ page: 'hotel_details' })

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    sendClickShowMore({ section: 'show_more_rooms' })
    onClick()
  }

  return (
    <Button
      data-testid={dataTestId}
      rounded
      outlined={outlinedShowMoreButton}
      filledLight={!outlinedShowMoreButton}
      size="m"
      type="button"
      onClick={handleClick}
    >
      {children}
      <IconArrowDown size={16} />
    </Button>
  )
}

export default ShowMore
